import { FC } from 'react';

import { useStoreConfigs } from 'commons/api/store-configs';
import { useSidemodalsContext } from 'commons/utils/hooks/useModal';

import { ChargeHistory } from 'domains/balance';
import BalanceAddCredit from 'domains/balance/components/add-credit';

import AddCredit from '../../../commons/components/add-credit';

const Sidemodals: FC = () => {
  const { state } = useSidemodalsContext();
  const { data: storeConfigs } = useStoreConfigs();

  return (
    <>
      {state.addCredit &&
        (storeConfigs?.nuvemPagoTransferEnabled ? (
          <BalanceAddCredit />
        ) : (
          <AddCredit />
        ))}

      {state.chargeHistory && <ChargeHistory />}
    </>
  );
};

export default Sidemodals;
